<template>
  <require from="controls/bs-form-switch"></require>
  <div class="info-box">
    <div class="info-box-summary">
      <bs-form-switch text="Filter when moving map" checked.bind="model.isSynchronized" disabled.bind="disabled"></bs-form-switch>
      <bs-form-switch text="Show all BP sites" checked.bind="model.areSitesDisplayed"></bs-form-switch>
    </div>
  </div>
</template>
